// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"e47d16c5","423":"aee92e2b","453":"32df3a64","527":"4b1649a8","980":"3750e5e6"}[chunkId] + ".chunk.js";
};